import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="w-full border-t border-white/5 py-8">
      <div className="max-w-5xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-4">
        <span className="text-xs text-white/20 tracking-widest uppercase font-medium">
          © {new Date().getFullYear()} Wingcue
        </span>
        <div className="flex items-center gap-8">
          <Link
            to="/support"
            className="text-xs text-white/30 hover:text-white/70 transition-colors duration-300 tracking-wide uppercase font-medium"
          >
            Support
          </Link>
          <div className="w-px h-3 bg-white/10" />
          <Link
            to="/terms"
            className="text-xs text-white/30 hover:text-white/70 transition-colors duration-300 tracking-wide uppercase font-medium"
          >
            Terms
          </Link>
          <div className="w-px h-3 bg-white/10" />
          <Link
            to="/privacy"
            className="text-xs text-white/30 hover:text-white/70 transition-colors duration-300 tracking-wide uppercase font-medium"
          >
            Privacy
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;